import React, { useCallback } from 'react';
import styles from './styles';
import moment from 'moment';
import i18n from 'i18next';

type Translation = { [key: string]: string };

const Button = ({ title, start, end, onChange, closeDatePicker }) => {
  const onClick = useCallback(() => {
    onChange({ startDate: start, endDate: end });
    closeDatePicker();
  }, [start, end]);
  return <button onClick={onClick}>{title}</button>;
};
export default ({ onChange, closeDatePicker }) => {
  const translationValues = i18n.t('common:general.date_picker', {
    returnObjects: true,
  }) as Translation;

  const RANGES = [
    {
      title: translationValues.today,
      start: moment().startOf('day'),
      end: moment().endOf('day'),
    },
    {
      title: translationValues.yesterday,
      start: moment().subtract(1, 'days').startOf('day'),
      end: moment().subtract(1, 'days').endOf('day'),
    },
    {
      title: translationValues.last_7_days,
      start: moment().subtract(7, 'days').startOf('day'),
      end: moment().subtract(1, 'days').endOf('day'),
    },
    {
      title: translationValues.last_30_days,
      start: moment().subtract(30, 'days').startOf('day'),
      end: moment().subtract(1, 'days').endOf('day'),
    },
    {
      title: translationValues.last_90_days,
      start: moment().subtract(90, 'days').startOf('day'),
      end: moment().subtract(1, 'days').endOf('day'),
    },
    {
      title: translationValues.last_month,
      start: moment().subtract(1, 'months').startOf('month'),
      end: moment().subtract(1, 'months').endOf('month'),
    },
  ];

  return (
    <div className={styles.predefined}>
      {RANGES.map((date) => (
        <Button
          key={date.title}
          {...date}
          onChange={onChange}
          closeDatePicker={closeDatePicker}
        />
      ))}
    </div>
  );
};
